"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Button_1 = __importDefault(require("@components/Button"));
var statDateUtil_1 = require("@features/StatisticPage/components/DatePicker/statDateUtil");
var ReportModal_1 = require("@features/StatisticPage/components/ReportModal");
var _store_1 = require("@store");
var date_1 = require("@utils/date/date");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var queuesSlice_1 = require("../Queues/state/queuesSlice");
var DatePicker_1 = require("./components/DatePicker");
var OverviewParts_1 = require("./components/OverviewParts");
var overviewSlice_1 = require("./state/overviewSlice");
function ErrorLoadingStats(_a) {
    var reloadHandler = _a.reloadHandler;
    var errorLoadingStats = (0, react_redux_1.useSelector)(overviewSlice_1.errorOverviewSelector);
    var loadingStats = (0, react_redux_1.useSelector)(overviewSlice_1.loadingOverviewSelector);
    var t = (0, react_i18next_1.useTranslation)().t;
    return (react_1.default.createElement(react_1.default.Fragment, null, !loadingStats && errorLoadingStats && (react_1.default.createElement("div", { className: "loading-error" },
        react_1.default.createElement("h2", null, t('DASHBOARD.STATISTICS.ERROR')),
        react_1.default.createElement(Button_1.default, { onClick: reloadHandler, text: t('DASHBOARD.STATISTICS.RELOAD_BUTTON') })))));
}
function Overview(_a) {
    var domain = _a.domain, teamName = _a.teamName, currentUserEmail = _a.currentUserEmail, userRoleName = _a.userRoleName, angularJsDependencies = _a.angularJsDependencies;
    var dispatch = (0, _store_1.useAppDispatch)();
    var getQueues = function () { return dispatch((0, queuesSlice_1.fetchQueues)(domain)); };
    var getTotalReceived = function (data) { return data.reduce(function (acc, item) { return acc + item.received; }, 0); };
    var loadStats = function (from, to) {
        var timeZoneParam = (0, date_1.getUserTimezone)();
        var fromParam = from.valueOf();
        var toParam = to.setMilliseconds(999).valueOf();
        var searchTimeQueryParam = "(metadata.created: [".concat(fromParam, " TO ").concat(toParam, "])");
        // should we define an action containing all consecutive call or use useEffect hooks for second call?
        // fetchOverviewReport action contains getOverallStatistics and searchDocuments
        dispatch((0, overviewSlice_1.fetchOverviewReport)(domain, fromParam, toParam, encodeURIComponent(timeZoneParam), getTotalReceived, userRoleName));
        if (userRoleName !== 'Spectator') {
            dispatch((0, overviewSlice_1.fetchDocumentCount)(domain, searchTimeQueryParam));
        }
    };
    var reloadHandler = function () {
        var urlParams = new URLSearchParams(window.location.search);
        var _a = __read((0, statDateUtil_1.getDefaultValuesFromUrlParams)(urlParams), 2), urlFromValue = _a[0], urlToValue = _a[1];
        loadStats(urlFromValue, urlToValue);
    };
    (0, react_1.useEffect)(function () {
        getQueues();
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "stat-top" },
            react_1.default.createElement(DatePicker_1.StatDatePicker, { className: "overview-date-pickers table-input", loadStats: loadStats, angularJsDependencies: angularJsDependencies }),
            (userRoleName === 'Admin' || userRoleName === 'Automation specialist') && (react_1.default.createElement(ReportModal_1.ReportModal, { domain: domain, teamName: teamName, currentUserEmail: currentUserEmail }))),
        react_1.default.createElement("div", null,
            react_1.default.createElement(OverviewParts_1.OverviewContent, null),
            react_1.default.createElement(OverviewParts_1.EmptyStat, { angularJsDependencies: angularJsDependencies }),
            react_1.default.createElement(ErrorLoadingStats, { reloadHandler: reloadHandler })),
        react_1.default.createElement(OverviewParts_1.StatLoader, null)));
}
exports.default = Overview;
